// 챗 아이콘 컴포넌트

const ChatUserIcon = ({ iconImg, nickname, agent, color }) => {
  const landyClass = nickname === "랜디" && "bg-transparent w-14 h-12"
  const bgColor = agent ? "bg-[#813DB5]" : `bg-brand-color`;

  return (
    <div className="flex items-center gap-1.5 mb-2.5">
      <div
        className={`p-1 flex justify-center items-center w-11 h-11 rounded-[18px] ${bgColor} ${landyClass}`}
      >
        <img src={iconImg} alt="Profile" />
      </div>
      <p className="text-sm font-semibold text-brand-text">{nickname}</p>
    </div>
  );
};

export default ChatUserIcon;
